import React, { FC } from 'react';
import { MdError, MdDelete } from 'react-icons/md';
import {
  MenuItem,
  Modal,
  Button,
  Center,
  Heading,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  useToast,
  useDisclosure,
  Text,
} from '@chakra-ui/react';
import { deleteImpactReport } from 'api/reports';
import { useMutation, useQueryClient } from 'react-query';
import { useDeleteReportMutation } from 'api/mutations/deleteReportMutation';

type Props = {
  inventoryReportId: string;
};

export const DeleteReportMenuItem: FC<Props> = ({ inventoryReportId }) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useDeleteReportMutation();

  return (
    <>
      <MenuItem
        icon={<MdDelete size="18px" />}
        onClick={(e) => {
          e.stopPropagation();
          onOpen();
        }}>
        Delete Report
      </MenuItem>
      <Modal
        size="2xl"
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="30px">
          <ModalCloseButton _focus={{ outline: 'none' }} />
          <ModalBody textAlign="center">
            <Center>
              <MdError size="100px" fill="red" />
            </Center>
            <Heading
              color="support.500"
              textAlign="center"
              fontSize="30px"
              whiteSpace="pre-line">
              Are you sure you want to delete this Impact Report?
            </Heading>
            <Text my={4} fontSize="20px">
              This action can't be undone
            </Text>
            <Center mb={5}>
              <Button mr={4} w="150px" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                isLoading={isLoading}
                colorScheme="red"
                onClick={() => {
                  mutate(inventoryReportId);
                  onClose();
                }}>
                Yes, Delete
              </Button>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteReportMenuItem;
